import { render, staticRenderFns } from "./ReceivableExpansionPanels.vue?vue&type=template&id=12635861&"
import script from "./ReceivableExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./ReceivableExpansionPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports